<template>
<div v-can="'external_forms.list'">
    <div class="search-container">
      <searchbar :value="query.search" @search="search" :model="model"></searchbar>
    </div>
  <general-listing
    @sorting="sorting"
    @itemDelete="itemDelete"
    :loading="loading"
    :data="items"
    :structure="collectionData"
    :params="{ global_sorting: true, sort_by: this.query.sort_by, sort_order: this.query.sort_order}"
    :has_searched="has_searched"
    model="external_form"
  />
  <pagination
    @goToPage="goToPage"
    :page="page"
    :total-pages="total_pages"
  />
  <external-form-create/>
</div>
</template>
<script>
import Api from '@/api/ExternalForm'
import {collectionMixin} from '@/components/mixins/Collection'
import { EventBus } from '@/EventBus.js';
import Ui from '@/classes/Ui'
import ExternalFormCreate from './ExternalFormCreate'
import Searchbar from '@/components/layouts/partials/Searchbar'
import GeneralListing from '@/components/helpers/Specific/GeneralListing'

let structure = [
  { name: 'id', sortable: true, credentials: 'root' },
  { name: 'name', type: 'show_with_edit_link' ,sortable: true },
  { name: 'project_name', type: 'project_link', sortable: true },
  { name: 'slug', type: 'form_slug' },
  { name: 'action', type: 'crud_action_folded' }
]

let default_sort_by = "created_at"
let default_sort_order = "DESC"
let default_filters = {}

export default {
  components: {
    ExternalFormCreate,
    Searchbar,
    GeneralListing
  },
  mixins: [collectionMixin],
  data(){
    return {
      model: "external_forms",
      api: new Api(),
      collectionData: structure,
      title: "ui.pages.external-forms",
      loading: false,
      query: { },
      formNavigation: [
        { name: "external_forms", action: "external_forms.list", credential: "external_forms.list" },
        { name: "email_templates", action: "email_templates.list", credential: "email_templates.list"},
      ],
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_EXTERNAL_FORMS',
        routerName: 'external_forms',
        emptyState: 'external_forms',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  },
  mounted(){
    if (this.page != Ui.getCurrentPageExternalForms()) {
      this.goToPage(Ui.getCurrentExternalForms())
    }

    Ui.setHeaderButtons([
      { name: "external_form", action: "external_form.add_popup", classes: "btn-primary"}
    ])
    Ui.setSecondaryHeaderTabs(this.formNavigation)

    EventBus.$off('external_form_duplicate')
    EventBus.$on('external_form_duplicate', this.duplicate)
  },
  beforeDestroy() {
    this.$store.commit('SET_SECONDARY_HEADER_TABS', [])
  },
  created(){
    //  In case we generate a query, we create it before to be able to retrieve it in collection and display the specific list.
    this.initQuery()
  },
  methods: {
    duplicate(payload){
      this.api.duplicate(payload.id).then(data=>{
        this.retrieve()
        let newForm = data.resource
        let route = { name: 'external_form_edit', params: { id: newForm.id }}
        this.$router.push(route)
      })
    }
  }
}
</script>
<style lang="scss">
.collection.external_form {

  .dot-navigation--trigger.icon{
    padding: 0;
  }
}
.search-container{
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  justify-content: space-between;
  .searchbar{
    margin-bottom: 1em;
    width: 100%;
  }
  .filter-trigger{
    user-select: none;
    cursor: pointer;
  }
  .icon-sliders {
    color: $onyx-light;
  }
}
</style>



// WEBPACK FOOTER //
// ExternalForms.vue?51c9a1ea